import { Navigate, useParams } from "react-router";
import { useAuth } from "./contexts/AuthContext";

const PrivateRoute = ({ children, allowedRoles }) => {
    const { user, role } = useAuth();
    const { personId } = useParams();

    // console.log("User:", user);
    // console.log("Route personId:", personId);

    // Not logged in
    if (!user) {
        return <Navigate to="/" replace />;
    }

    // Role not allowed
    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/bakedpotato" replace />;
    }

    // UID does not match route param
    if (personId && user.uid !== personId) {
        return <Navigate to="/bakedpotato" replace />;
    }

    return children;
};

export default PrivateRoute;